import {Link, Outlet} from 'react-router-dom';

import List from './List';
import CreateCouponForm from './forms/CreateCoupon.form';

import Meta from "../../components/Meta";

import styles from '../../../styles/Admin.module.scss';
import Header from "../../components/Header";

function Template() {
	return (
		<>
			<Meta title="Coupons" />

			<Header heading={"Coupons"} button={<Link to="create" className="btn btnPrimary">+ Create Coupon</Link>} />

			<main>
				<Outlet />
			</main>
		</>
	)
}

export default {
	Template,
	List,
	Create: CreateCouponForm,
};